import { Activity } from '@cms-max/medicare-api-sdk'
import generator, { EventMapKeys } from './baseGenerator'

export const mcfGenerator = generator(({ i18n }) => {
  return ({
    // PDT Drawer: Open
    mcf_pdtdrawer_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: 'MCF',
        elementId: 'mcf_pdtdrawer_opendrawer'
      }
    },
    // PDT Drawer: Close
    mcf_pdtdrawer_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: 'MCF',
        elementId: 'mcf_pdtdrawer_closedrawer'
      }
    },
    // MNT Drawer: Open
    mcf_mntdrawer_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: 'MCF',
        elementId: 'mcf_mntdrawer_opendrawer'
      }
    },
    // MNT Drawer: Close
    mcf_mntdrawer_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: 'MCF',
        elementId: 'mcf_mntdrawer_closedrawer'
      }
    }
  })
})

export type MCFKeys = EventMapKeys<typeof mcfGenerator>

export default mcfGenerator
